import "aos/dist/aos.css";
import "../index.css";

export default function Skills() {
  return (
    <>
      <div className="relative ml-4 sm:ml-20">
        <h1 className="text-2xl mt-20">Skills</h1>
        <div className="absolute left-1 sm:left-0 top-10 w-1 bg-gray-400 h-full"></div>
        <div className="ml-4 sm:ml-8 mt-10 flex flex-col">
          <div className="relative mb-10 flex items-center">
            <div className="absolute left-[-16px] sm:left-[-32px] w-1 bg-gray-400 h-10 top-[-10px]"></div>
            <div
              className="ml-4 sm:ml-8"
              data-aos="zoom-in-up"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
            >
              <h2 className="text-xl mb-6">Frontend Development</h2>
              <img
                src="https://skillicons.dev/icons?i=react,nextjs,html,css,javascript,angular,bootstrap,tailwind,redux"
                className="flex flex-wrap"
                alt="frontend"
              />
            </div>
          </div>
          <div className="relative mb-10 flex items-center">
            <div className="absolute left-[-16px] sm:left-[-32px] w-1 bg-gray-400 h-10 top-[-10px]"></div>
            <div
              className="ml-4 sm:ml-8"
              data-aos="zoom-in-up"
              data-aos-duration="1300"
              data-aos-easing="ease-in-out"
            >
              <h2 className="text-xl mb-6">Backend Development</h2>
              <img
                src="https://skillicons.dev/icons?i=nodejs,expressjs,javascript,docker,typescript"
                className="flex flex-wrap"
                alt="backend"
              />
            </div>
          </div>
          <div className="relative mb-10 flex items-center">
            <div className="absolute left-[-16px] sm:left-[-32px] w-1 bg-gray-400 h-10 top-[-10px]"></div>
            <div
              className="ml-4 sm:ml-8"
              data-aos="zoom-in-up"
              data-aos-duration="1600"
              data-aos-easing="ease-in-out"
            >
              <h2 className="text-xl mb-6">Databases</h2>
              <img
                src="https://skillicons.dev/icons?i=mongodb,mysql,supabase,firebase,nosql"
                className="flex flex-wrap"
                alt="db"
              />
            </div>
          </div>
          <div className="relative mb-10 flex items-center">
            <div className="absolute left-[-16px] sm:left-[-32px] w-1 bg-gray-400 h-full top-[-10px]"></div>
            <div
              className="ml-4 sm:ml-8"
              data-aos="zoom-in-up"
              data-aos-duration="2000"
              data-aos-easing="ease-in-out"
            >
              <h2 className="text-xl mb-6">Other Skills</h2>
              <img
                src="https://skillicons.dev/icons?i=java,py,materialui,vscode,netlify,idea,github,vercel"
                className="flex flex-wrap"
                alt="other skills"
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="border-gray-600 my-10" />
    </>
  );
}
